export function Logo({ className = "", height = 32, alt = "PranIQ", emblem = false, variant = "dark" }) {
  const src = emblem ? "/praniq-mark.png" : variant === "light" ? "/praniq-lockup-light.png" : "/praniq-lockup-transparent.png";
  return (
    <img
      src={src}
      alt={alt}
      style={{ height, width: "auto" }}
      className={className}
      draggable={false}
    />
  );
}
